import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import { useState } from "react";
import { toast } from "react-toastify";
import { t } from "i18next";

const StatusModal = ({ closeModal, praticaId, setStatus }) => {
  const [selectedStatus, setSelectedStatus] = useState(""); // Stato per il valore selezionato nella select
  const states = ["Aperta", "In Attesa", "In Lavorazione", "Chiusa"]; // Lista degli stati disponibili

  const handleSave = () => {
    let trimmedStatus = selectedStatus.trim().replace(/\s+/g, "");
    trimmedStatus === "Chiusa" && (trimmedStatus = "ChiusaPositivo");
    setStatus({ practiceId: praticaId, status: trimmedStatus })
      .then(() => {
        toast.success(`Stato ${t("practice")} aggiornato`);
        closeModal();
      })
      .catch((error) => {
        toast.error(`Stato ${t("practice")} non aggiornato`);
      });
  };

  return (
    <div className="flex flex-col items-center">
      <h3>{t("PracticeStatusExt")}</h3>
      <div style={{ width: "500px", marginTop: "30px", paddingInline: "30px" }}>
        <FormControl fullWidth size="small">
          <InputLabel id="servizio-label">{t("PracticeStatus")}</InputLabel>
          <Select
            label="servizio-label"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            {states.map((state, index) => (
              <MenuItem key={index} value={state}>
                {state}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <CoreButton
        sx={{
          marginTop: 5,
        }}
        className={"btn-round"}
        variant="contained"
        testo={t("Edit")}
        onClick={handleSave}
      />
    </div>
  );
};

export default StatusModal;
